export const VEHICLE_ONBOARDING_STEPS = "VEHICLE_ONBOARDING_STEPS";
export const VEHICLE_FORM_DATA_SET = "VEHICLE_FORM_DATA_SET";

export const SUBMIT_FORM_START = "SUBMIT_FORM_START";
export const SUBMIT_FORM_SUCCESS = "SUBMIT_FORM_SUCCESS";
export const SUBMIT_FORM_FAIL = "SUBMIT_FORM_FAIL";

export const FETCH_VARIANTS_START = "FETCH_VARIANTS_START";
export const FETCH_VARIANTS_SUCCESS = "FETCH_VARIANTS_SUCCESS";
export const FETCH_VARIANTS_FAIL = "FETCH_VARIANTS_FAIL";

export const SET_AVAILABLE_FILTERS = "SET_AVAILABLE_FILTERS";
export const SET_CURRENT_FILTERS = "SET_CURRENT_FILTERS";
export const SET_SELECTED_VARIANT = "SET_SELECTED_VARIANT";

export const SET_APPOINTMENTID = "SET_APPOINTMENTID";
export const SET_STOCKID = "SET_STOCKID";

export const RESET_VEHICLE_FORM_DATA = "RESET_VEHICLE_FORM_DATA";

export const GET_VEHICLE_DATA_START = "GET_VEHICLE_DATA_START";
export const GET_VEHICLE_DATA_SUCCESS = "GET_VEHICLE_DATA_SUCCESS";
export const GET_VEHICLE_DATA_FAIL = "GET_VEHICLE_DATA_FAIL";

export const FETCH_VENDORS_START = "FETCH_VENDORS_START";
export const FETCH_VENDORS_SUCCESS = "FETCH_VENDORS_SUCCESS";
export const FETCH_VENDORS_FAIL = "FETCH_VENDORS_FAIL";

export const SET_STEP_FIVE_URL = "SET_STEP_FIVE_URL";
